import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'
export abstract class _CopywritingBase extends BaseCssVarValue {
  abstract cssType: 'default' | 'small'
  /** 内容的间距 */
  ['--copywriting-gap']?: string;
  /** 标题字号 */
  ['--headline-font-size']?: string;
  /** logo宽度 */
  ['--logo-width']?: string;
  /** logo高度 */
  ['--logo-height']?: string;
  /** 主标题名称字号 */
  ['--name-font-size']?: string;
  /** 描述文案字号 */
  ['--description-font-size']?: string
}
